export default __webpack_public_path__ + "static/media/001-W-veuve.d5e34ae9.svg";